import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { verifyAccountRequest } from '../redux/actions/account_actions/verify_account.actions';
import LogInForm from './LogInForm';

const mapStateToProps = (state) => {
    const { isVerifying, hasVerifying } = state.App.Verify_account_form;
    return { isVerifying, hasVerifying };
};

export default connect(mapStateToProps, null)(class EmailConfirmation extends Component {
    componentDidMount() {
        const token = this.props.location.search.substr(7);
        this.props.dispatch(verifyAccountRequest(token));
    }

    render() {
        const { isVerifying, hasVerifying } = this.props;
        if (isVerifying) return null;
        return !hasVerifying
            ? (
                <div className="account noAccess">
                    <div className="account__wrapper">
                        <div className="account__card">
                            <div className="account__header">
                                <h4 className="account__error">Oops... something gone wrong!</h4>
                            </div>
                            <p>Unfortunately you do not have access to the SuperBike Factory platform.</p>
                            <p><Link to="/auth/register">Back to Signup Page</Link></p>
                        </div>
                    </div>
                </div>
            ) : <LogInForm />;
    }
});



// WEBPACK FOOTER //
// ./src/modules/App/components/EmailConfirmation.js